// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { getApiUrl } from "utils";
import { API_URL } from "constants/api";

type TokenListParams = {
  offset: number;
  limit: number;
  sortby: string;
  sorttype: string;
};
type TransferParams = {
  address: string;
};
// Define a service using a base URL and expected endpoints
export const tokenApi = createApi({
  reducerPath: "tokens",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getTokenList: builder.query<any, TokenListParams>({
      query: ({ offset, limit, sortby, sorttype }) =>
        `token/list?offset=${offset}&limit=${limit}&sort_by=${sortby}&sort_type=${sorttype}`,
    }),
    getTokenOverview: builder.query<any, string>({
      query: (address) => `token/overview?address=${address}`,
    }),
    getTokenTransfer: builder.query<
      any,
      { address: string; offset: number; limit: number }
    >({
      query: ({ address, offset, limit }) =>
        `token/transfer?address=${address}&offset=${offset}&limit=${limit}`,
    }),
    getTokenHolder: builder.query<
      any,
      { address: string; offset: number; limit: number }
    >({
      query: ({ address, offset, limit }) =>
        `token/holder?address=${address}&offset=${offset}&limit=${limit}`,
    }),
    getHolderByTime: builder.query<
      any,
      { address: string; type: string; size: number }
    >({
      query: ({ address, type, size }) =>
        `token/holder_statistic?address=${address}&type=${type}&size=${size}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetTokenListQuery,
  useGetTokenOverviewQuery,
  useGetTokenTransferQuery,
  useGetTokenHolderQuery,
  useGetHolderByTimeQuery,
} = tokenApi;
